// removed by extract-text-webpack-plugin
module.exports = {"button":"exY2XxzKqaQGzKwXMiaos","preset_default":"_60FyaZbmWjMM01AFQBnMR","presetDefault":"_60FyaZbmWjMM01AFQBnMR","preset_accent":"MuuZkCxS-4Z2klRsp-PK","presetAccent":"MuuZkCxS-4Z2klRsp-PK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Button/Button.styl
// module id = 129
// module chunks = 0